module.exports.INGREDIENTS = [
  {
    id: "LEMON_SELTZER",
    name: "Lemon Seltzer",
  },
  {
    id: "KIWI_STRAWBERRY_SNAPPLE",
    name: "Kiwi Strawberry Snapple",
  },
  {
    id: "COCA_COLA",
    name: "Coca-Cola",
  },
  {
    id: "ORANGE_JUICE",
    name: "Orange Juice",
  },
  {
    id: "MOCHA_ICED_COFFEE",
    name: "Mocha Iced Coffee",
  },
  {
    id: "BLUE_POWERADE",
    name: "Mountain Berry Powerade",
  }
];
